import { GpsFixIcon, MapWithMarker, Mtds } from 'prove-common'
import { ManualLocationRegistrationModal } from 'prove-common'
import { useState } from 'react'

type SavedLocationCardProps = {
  position: GeolocationPosition
  sampleId?: string
  deferSave?: boolean
  onSelectedLonLatChanged?: (lonLat: [number, number]) => void
}

export const SavedLocationCard = ({
  position,
  sampleId,
  deferSave,
  onSelectedLonLatChanged
}: SavedLocationCardProps) => {
  const [isManualModalOpen, setIsManualModalOpen] = useState(false)

  return (
    <Mtds.Card as={Mtds.Grid} data-gap={8}>
      <Mtds.Info>
        <GpsFixIcon />
        <strong>Registrert posisjon</strong>
      </Mtds.Info>
      <MapWithMarker
        latitude={position.coords.latitude}
        longitude={position.coords.longitude}
      />
      <Mtds.Button
        data-variant='secondary'
        onClick={() => setIsManualModalOpen(true)}
      >
        Endre posisjon
      </Mtds.Button>
      {isManualModalOpen && (
        <ManualLocationRegistrationModal
          isManualModalOpen={isManualModalOpen}
          setIsManualModalOpen={setIsManualModalOpen}
          sampleId={sampleId}
          position={position}
          deferSave={deferSave}
          onSelectedLonLatChanged={onSelectedLonLatChanged}
        />
      )}
    </Mtds.Card>
  )
}
